var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: "element " + (_vm.selected ? "selected" : "") }, [
    _c("span", { staticClass: "element-title" }, [
      _c("i", {
        class:
          "" +
          (_vm.element.items.length > 0
            ? _vm.expanded
              ? "el-icon-arrow-down"
              : "el-icon-arrow-right"
            : ""),
        on: { click: _vm.toggle },
      }),
      _c(
        "p",
        {
          on: {
            click: function ($event) {
              return _vm.labelClick(_vm.element)
            },
          },
        },
        [_vm._v(_vm._s(_vm.element.menuTitle))]
      ),
    ]),
    _vm.element.items
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.expanded,
                expression: "expanded",
              },
            ],
            staticClass: "element-children",
          },
          _vm._l(_vm.element.items, function (item, index) {
            return _c("data-tree-element", {
              key: index,
              attrs: { element: item },
              on: { "label-click": _vm.labelClick },
            })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }